import { ArrowRightIcon } from '@heroicons/react/outline';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import Mail from '@/assets/mail.svg';
import { Button } from '@/components/Elements';
import { APP_HOME_URL } from '@/config';

export type FormConfirmProps = {
  title?: React.ReactNode | string;
  description?: React.ReactNode | string;
  actionButton?: React.ReactNode | string;
  actionButtonIcon?: boolean;
  actionURL?: string;
  onClickAction?: () => void;
  className?: string;
  image?: React.ReactNode | string;
  imageWidth?: string;
  imageHeight?: string;
};

export const FormConfirm = ({
  title,
  description,
  actionButton,
  actionButtonIcon = true,
  actionURL,
  onClickAction,
  image,
  imageWidth,
  imageHeight,
  className = '',
}: FormConfirmProps) => {
  const { t } = useTranslation();
  const onClick = () => {
    if (onClickAction) {
      onClickAction();
      return;
    }

    window.location.assign(actionURL || APP_HOME_URL);
  };

  const getImage = (image: React.ReactNode | string) => {
    if (typeof image === 'object') {
      return image;
    }

    if (typeof image === 'string') {
      return (
        <img
          className="block m-auto"
          alt={t('FormConfirm.thanks')}
          src={image}
          width={imageWidth || '180'}
          height={imageHeight || '180'}
        />
      );
    }

    return false;
  };

  const getButtonWithIcon = () => {
    return (
      <Button
        variant="rounded"
        className="m-auto text-lg"
        endIcon={<ArrowRightIcon className="h-5 w-5 text-md-purple" aria-hidden="true" />}
        onClick={onClick}
      >
        {actionButton || t('common.backToMDirector')}
      </Button>
    );
  };

  const getButtonWithoutIcon = () => {
    return (
      <Button variant="rounded" className="m-auto text-lg" onClick={onClick}>
        {actionButton || t('common.backToMDirector')}
      </Button>
    );
  };

  return (
    <div className={`${className} w-full h-full text-center py-4 px-12`}>
      {getImage(image || Mail)}
      <div className="text-3xl text-black font-black mt-3">{title || t('FormConfirm.title')}</div>
      <div className="mt-8 text-lg">{description || t('FormConfirm.description')}</div>
      <div className="m-auto mt-12">
        {actionButtonIcon ? getButtonWithIcon() : getButtonWithoutIcon()}
      </div>
    </div>
  );
};
